import { CACHE } from '~/composables/mercure/shared/constants';

const regexCache = new Map<string, RegExp>();

function getOrCreateRegex (patternStr: string): RegExp {
  const cached = regexCache.get(patternStr);
  if (cached) {
    return cached;
  }

  let regexPattern = patternStr
    .replace(/[.+?^$|()[\]\\]/g, '\\$&')
    .replace(/\*/g, '[^/]*')
    .replace(/\{[^}]*\}/g, '[^/]+');

  regexPattern = `^${regexPattern}$`;
  const regex = new RegExp(regexPattern);

  if (regexCache.size >= CACHE.REGEX_MAX_SIZE) {
    const firstKey = regexCache.keys().next().value;
    regexCache.delete(firstKey);
  }

  regexCache.set(patternStr, regex);
  return regex;
}

export function hasWildcard (pattern: string): boolean {
  return pattern.includes('*') || pattern.includes('{');
}

export function matchesPattern (pattern: string, topic: string): boolean {
  if (pattern === topic) {
    return true;
  }

  if (!hasWildcard(pattern)) {
    return false;
  }

  const regex = getOrCreateRegex(pattern);
  return regex.test(topic);
}
